var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"clock"}},[_c('span',{staticClass:"time h4"},[_vm._v(_vm._s(_vm.time))])])}
var staticRenderFns = []

export { render, staticRenderFns }